var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24778 1.5L5.25 1.5H15.375L15.3771 1.5C16.2709 1.50255 17.1273 1.85872 17.7593 2.4907C18.3913 3.12268 18.7475 3.97911 18.75 4.87287C18.75 4.87879 18.75 4.8847 18.7498 4.89062L18.7423 5.25H19.0781C20.968 5.25 22.5 6.78203 22.5 8.67188V19.0781C22.5 20.968 20.968 22.5 19.0781 22.5H8.67188C6.78203 22.5 5.25 20.968 5.25 19.0781V18.75H4.875L4.87287 18.75C3.97911 18.7475 3.12268 18.3913 2.4907 17.7593C1.85872 17.1273 1.50255 16.2709 1.5 15.3771L1.5 15.375V5.25L1.5 5.24778C1.50294 4.25471 1.89874 3.30315 2.60095 2.60095C3.30315 1.89874 4.25471 1.50294 5.24778 1.5ZM6.75 19.0781C6.75 20.1395 7.61045 21 8.67188 21H19.0781C20.1395 21 21 20.1395 21 19.0781V8.67188C21 7.61045 20.1395 6.75 19.0781 6.75H17.9791C17.9776 6.75 17.9761 6.75 17.9746 6.75H8.67188C7.61045 6.75 6.75 7.61045 6.75 8.67188V19.0781ZM17.242 5.25H8.67188C6.78203 5.25 5.25 6.78203 5.25 8.67188V17.25H4.87621C4.37913 17.2483 3.90287 17.0501 3.55136 16.6986C3.19987 16.3471 3.00167 15.8709 3 15.3738V5.25119C3.00203 4.65478 3.23986 4.08335 3.66161 3.66161C4.08335 3.23986 4.65478 3.00203 5.25119 3H15.3738C15.8709 3.00167 16.3471 3.19987 16.6986 3.55136C17.0484 3.90117 17.2464 4.37454 17.25 4.86902L17.242 5.25Z",
    fill: "#FFC900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4700a8a53aa0137c15dfdbe786021b2f.svg";
export { ForwardRef as ReactComponent };